import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  Text,
} from '@lightspeed/design-system-react'
import { T } from '@transifex/react'
import React, { FunctionComponent, useState } from 'react'
import { createPortal } from 'react-dom'
import { CashFloatForm } from '../cash-management/CashFloatForm'
import { CashFloatSettings } from '../cash-management/utils/types'
import { useCashMovementsManager } from '../../ng-compat/hooks'
import { CASH_MOVEMENT_TYPES } from '../../constants'

interface OpenRegisterModalProps {
  onClose: (result: CashFloatSettings | undefined) => void
}

const dummyCashFloatSettings = {
  amount: '0.00',
  note: '',
  type: CASH_MOVEMENT_TYPES.OPENING_CASH_FLOAT,
}

export const OpenRegisterModal: FunctionComponent<OpenRegisterModalProps> = ({
  onClose,
}) => {
  const [hasErrors, setHasErrors] = useState(false)
  const cashMovementsManager = useCashMovementsManager()
  const cashMovementsEnabled = cashMovementsManager.isCashManagementEnabled()

  return createPortal(
    <Modal onClose={() => onClose(undefined)} size="small">
      <ModalHeader>
        <T _str="Register closed" />
      </ModalHeader>
      <ModalContent>
        <Text tag="p" className="vd-pb5">
          <T _str="To continue this sale, the register must be opened first" />
        </Text>
        {cashMovementsEnabled ? (
          <CashFloatForm onSubmit={onClose} onError={setHasErrors}>
            <div className="btn-group vd-align-right">
              <Button
                variant="supplementary"
                onClick={() => onClose(undefined)}
              >
                <T _str="Cancel" />
              </Button>
              <Button type="submit" className="vd-ml2" disabled={hasErrors}>
                <T _str="Open register and continue sale" />
              </Button>
            </div>
          </CashFloatForm>
        ) : null}
      </ModalContent>
      {cashMovementsEnabled ? null : (
        <ModalActions>
          <div className="btn-group vd-align-right">
            <Button variant="supplementary" onClick={() => onClose(undefined)}>
              <T _str="Cancel" />
            </Button>
            <Button
              onClick={() => onClose(dummyCashFloatSettings)}
              className="vd-ml2"
              disabled={hasErrors}
            >
              <T _str="Open register and continue sale" />
            </Button>
          </div>
        </ModalActions>
      )}
    </Modal>,
    document.body
  )
}
